import React, { useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SelfieVerificationCheck from './SelfieVerificationCheck';
import { JoinProvider } from '../../../contexts/JoinContext';
import { RootState } from '../../../store';
import { updateShowTutorialOffer } from '../../../actions/profileActions';

export const SelfieVerificationWall = ({ isJoinFlow }) => {
  const { liveness, showSelfieVerificationWall } = useSelector((state: RootState) => state.profile);

  const attributes = useSelector((state: RootState) => state.attributes);
  const errors = useSelector((state: RootState) => state.common.errors);
  const [, setShowJoinForm] = useState(false);
  const [showVerifyWall, setShowVerifyWall] = useState(false);
  const dispatch = useDispatch();

  useMemo(() => {
    setShowVerifyWall(showSelfieVerificationWall);
  }, [showSelfieVerificationWall]);

  if (showSelfieVerificationWall) {
    return (
      <>
        <JoinProvider
          onFormSubmitted={() => {
            //
          }}
          setShowJoinForm={setShowJoinForm}
          isEuUser={false}
          attributes={attributes}
          errors={errors}
          updateOfferTutorialState={() => {
            dispatch(updateShowTutorialOffer(false));
          }}
          liveness={liveness}
        >
          <SelfieVerificationCheck
            isJoinFlow={isJoinFlow}
            showVerifyWall={showVerifyWall}
            setShowVerifyWall={setShowVerifyWall}
          />
        </JoinProvider>
      </>
    );
  }

  return <></>;
};
